/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.users.detail.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.view.application.users.addGroupsModal.controllers',
  'acme.view.application.users.removeGroupModal.controllers'
])

.controller('UsersDetailController', ['$scope', '$state', '$uibModal', 'ApiService', 'PermissionsService', 'CalendarService', function($scope, $state, $uibModal, ApiService, PermissionsService, CalendarService) {

    $scope.usersDetail = {

      model: {},
      addModal: {},
      removeModal: {},

      events: [],
      roles: [],
      groups: [],
      permissions: [],
      currentView: '',
      visibleStartDate: '',
      startTime: CalendarService.toISO8601(new Date()),
      endTime: CalendarService.toISO8601(new Date().setMonth((new Date()).getMonth() + 1)),

      userDetails: {
        columns: 2,
        columnWidth: 4,
        data: 'usersDetail.model',
        sorting: false,
        include: [
          'firstName',
          'lastName',
          'title',
          'email',
          'phoneNumber',
          'streetAddress1',
          'streetAddress2',
          'country',
          'city',
          'state',
          'zipCode'
        ]
      },

      init: function() {

        var titleData = {
          title: 'User Details'
        };

        $scope.$emit('Application::viewChange', { view: 'full' });
        $scope.$on('$destroy', this.onDestroy);

        if ($state.params && $state.params.id) {
          this.getUser($state.params.id);
          this.getGroups($state.params.id);
          //this.getRoles($state.params.id);


          $scope.$on('calendar[users-view-calendar]::onViewRender', function(e, data) {
            var visibleStartDate = new Date(data.view.visStart).getTime();
            console.log('calendar[users-view]::onViewRender', data);
            if (data.view.start && data.view.end && ($scope.usersDetail.currentView !== data.view.name || $scope.usersDetail.visibleStartDate !== visibleStartDate)) {
              $scope.usersDetail.startTime = CalendarService.toISO8601(data.view.start);
              $scope.usersDetail.endTime = CalendarService.toISO8601(data.view.end);
              $scope.usersDetail.currentView = data.view.name;
              $scope.usersDetail.visibleStartDate = visibleStartDate;
              $scope.usersDetail.getEvents($state.params.id);
            }
          });

        }

        $scope.$emit('Application::contentTitleChange', titleData);
      },

      getUser: function(id) {
        ApiService.user.view(id).then(this.success.getUser, this.error.getUser);
      },

      getRoles: function(id) {
        ApiService.user.roles.list(id).then(this.success.getRoles, this.error.getRoles);
      },

      getGroups: function(id) {
        ApiService.user.groups.list(id).then(this.success.getGroups, this.error.getGroups);
      },

      getGroupDetails: function(groupId) {
        return (PermissionsService.check('USER_GROUPS_VIEW')) ? 'application.groups.roles({ id: '+groupId+' })' : '.';
      },

      hasRoles: function() {
        return (this.roles instanceof Array && this.roles.length > 0);
      },

      hasGroups: function() {
        return (this.groups instanceof Array && this.groups.length > 0);
      },

      findGroup: function(id) {

        var i, ii,
          r = false;

        for (i=0,ii=this.groups.length;i<ii;i++) {
          if (this.groups[i].id === id) {
            r = {
              group: this.groups[i],
              index: i
            };
          }
        }

        return r;

      },
      
      getGroupIds: function() {
        var i, ii,
          ids = [];

        for (i=0,ii=this.groups.length;i<ii;i++) {
          ids.push(this.groups[i].userGroupMapId);
        }

        return ids;
      },

      getDeltas: function(list) {
        var i, ii,
          j, jj,
          remove,
          r = {
            ids: [],
            list: {
              mappings: angular.copy(list.mappings),
              groups: angular.copy(list.groups)
            }
          };

        // Only return items to be removed from the list
        // Splice out duplicates to only retain unique values
        for (i=0,ii=this.groups.length;i<ii;i++) {
          remove = true;
          for (j=r.list.mappings.length - 1,jj=0;j>=jj;j--) {
            if (this.groups[i].id === r.list.mappings[j].userGroupId) {
              console.log('GroupsRolesController::getRemovals', this.groups[i].id, r.list.mappings[j].userGroupId);
              r.list.mappings.splice(j, 1);
              r.list.groups.splice(j, 1);
              remove = false;
              break;
            }
          }
          if (remove && this.groups[i].userGroupMapId) {
            r.ids.push(this.groups[i].userGroupMapId);
          }
        }
        console.log('GroupsRolesController::getRemovals', r);

        return r;
      },

      addBatch: function(list, deltaList) {
        var batchMappings = list.mappings;

        if (deltaList && deltaList.hasOwnProperty('mappings')) {
          batchMappings = deltaList.mappings;
        }

        ApiService.groups.userMaps.batchCreate({ mappings: batchMappings }).then(function (response, status, headers, config) {
          var i, ii,
            j, jj,
            self = $scope.usersDetail,
            mappings = response.data.payload;

          // Remap userGroupMapIds to model for deletions to work
          for (i=0,ii=mappings.length;i<ii;i++) {
            for (j=0,jj=list.groups.length;j<jj;j++) {
              if (mappings[i].userGroupId === list.groups[j].id) {
                list.groups[j].userGroupMapId = mappings[i].id;
              }
            }
          }
          self.groups = list.groups;
          self.success.addBatch(response, status, headers, config);
        }, this.error.addBatch);
      },

      addGroup: function() {
        var self = $scope.usersDetail;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/users/modals/addGroups.tpl.html',
          size: 'md',
          controller: 'UsersAddGroupsModalController',
          resolve: {
            userData: function() {
              return self.model;
            },
            userGroups: function() {
              return self.groups;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (list) {
          var delta = self.getDeltas(list);

          if (delta.ids.length > 0) {
            ApiService.groups.userMaps.remove({ ids: delta.ids }).then(function (response) {
              // Clear users to prevent duplicates
              self.groups = [];
              // Add users
              self.addBatch(list, delta.list);
            }, self.error.addGroup);
          }else{
            self.addBatch(list, delta.list);
          }
        }, function () {
          // Do nothing
        });

      },

      removeGroup: function(id) {
        var self = $scope.usersDetail,
          found = self.findGroup(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/users/modals/removeGroup.tpl.html',
          size: 'md',
          controller: 'UsersRemoveGroupModalController',
          resolve: {
            currentGroup: function() {
              return found.group;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          ApiService.groups.userMaps.remove({ ids: [found.group.userGroupMapId] }).then(function(response, status, headers, config) {
            self.groups.splice(found.index, 1);
            self.success.remove(response, status, headers, config);
          }, function(response, status, headers, config) {
            self.error.remove(response, status, headers, config);
          });
        }, function () {
          // Do nothing
        });
      },

      getEvents: function(id) {

        $scope.usersDetail.events.length = 0;

        ApiService.entity.schedules.owner({
          ownerId: id,
          startTime: this.startTime,
          endTime: this.endTime
        }).then(this.success.getEvents, this.error.getEvents);
      },

      processEvents: function(events) {

        var i, ii,
          start,
          end,
          r = [];

        for (i=0,ii=events.length;i<ii;i++) {
          start = new Date(events[i].startDateTime);
          end = new Date(events[i].endDateTime);

          r.push({
            id: events[i].eventId,
            title: events[i].eventName,
            start: start,
            end: end,
            allDay: ((start-end)/(1000*60*60*24) >= 1)
          });
        }

        return r;

      },

      success: {
        getUser: function(response) {
          var titleData = {
                title: ''
              },
              self = $scope.usersDetail;

          console.log('UsersViewController::success:getUser', response);
          self.model = response.data.user;

          self.model.hideActionButton = !!(self.model.category && self.model.category === 'internal')

          if (self.model.firstName) {
            titleData.title = self.model.firstName;
            if (self.model.lastName) {
              titleData.title += ' ' + self.model.lastName;
            }
          }else if (self.model.email) {
            titleData.title = self.model.email;
          }else{
            titleData.title = 'User Schedule';
          }

          if (!self.model.hideActionButton) {
            titleData.buttonRight = {
              permissions: 'USERS_UPDATE',
              label: 'Edit User',
              action: function() {
                $state.go('application.users.edit', { id: $state.params.id });
              }
            };
          }
          
          $scope.$emit('Application::contentTitleChange', titleData);

        },
        getEvents: function(response) {
          angular.copy($scope.usersDetail.processEvents(response.data.payload), $scope.usersDetail.events);
          $scope.$broadcast('calendarCreateEvent::events');
        },
        getRoles: function(response) {
          var self = $scope.usersDetail;
          self.roles = response.data.payload;
        },
        getGroups: function(response) {
          var self = $scope.usersDetail;
          self.groups = response.data.payload;
        },
        addGroup: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}

      },

      error: {
        getUser: function(response) {
          console.log('UsersViewController::error:getUser', response);
        },
        getEvents: function(response) {},
        getRoles: function(response) {},
        getGroups: function(response) {},
        addGroup: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}

      },

      onDestroy: function() {
        $scope.$emit('Application::viewChange', { view: 'sidebar' });
      }

    };

    $scope.usersDetail.init();

}]);